import React from 'react'
import Layout from '../../../components/common/pageLayout'
import Component from '../../../components/Production/pending/WeeklyTimeSheet'

const WeeklyTimeSheet = () => {
    return (

        <Layout
            title={'Weekly Time Sheet'}
        >
            <Component />


        </Layout>
    )
}

export default WeeklyTimeSheet